import React from 'react';
const navRef = React.createRef()
const footerRef = React.createRef()
const notifyRef = React.createRef()

export { navRef, footerRef, notifyRef }